import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getBillingOverviewInfo({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.billing.info, signal });

    yield put(actions.getBillingOverviewInfoDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBillingOverviewInfoFailed,
      endpoint: api.billing.info.url
    });
  }
}

export const getBillingOverviewInfoSaga = takeEvery(types.GET_BILLING_OVERVIEW_INFO_REQUEST, getBillingOverviewInfo);